// App.js
import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Website from "./accueil";
import Products from "./products";
import Destockage from "./destockage";
import Contact from "./contact";

import ProductDetail from "./ProductDetail";
import ProductsByCordon from "./ProductByCordon";
import Cart from "./Cart";
import Login from "./Login";
import Register from "./Register";
import Account from "./Account";
import CheckoutForm from "./CheckoutForm";
import Recapitulatif from "./Recapitulatif";
import MentionsLegales from "./MentionsLegales";
import Confidentialite from "./Confidentialite";
import CGV from "./CGV";
import Success from "./success";
import "./App.css";


const App = () => (
  <HelmetProvider>
    <Router>
      <Suspense
        fallback={
          <div className="page">
            <div className="container">
              <div className="card" style={{ textAlign: "center" }}>
                Chargement…
              </div>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Website />} />
          <Route path="/products" element={<Products />} />
          <Route path="/destockage" element={<Destockage />} />
          <Route path="/contact" element={<Contact />} />

          {/* ✅ Route SEO (recommandée) */}
          <Route path="/product/:id" element={<ProductDetail />} />

          {/* ✅ Compat ancienne URL */}
          <Route path="/products/:id" element={<Navigate to={(location) => location.pathname.replace("/products/", "/product/")} replace />} />

          <Route path="/cart" element={<Cart />} />
          <Route path="/cordon/:type" element={<ProductsByCordon />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/account" element={<Account />} />
          <Route path="/checkout-form" element={<CheckoutForm />} />
          <Route path="/recapitulatif" element={<Recapitulatif />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/success" element={<Success />} />

          {/* fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  </HelmetProvider>
);

export default App;
